import { GalleryController } from "../../../components/gallery/controller.js";

export class UserPrivateRealStateView {
  constructor() {
    this.gallery = new GalleryController('app.userPrivateController.inmuebles.view');
  }

  renderMain() {
    return `
      <div class="user-header">
        <h1>Mis inmuebles</h1>
      </div>
      `;
  }

  renderHeader() {
    return `
      <div class="service-header-content box">
        <h1>Mis inmuebles</h1>
        <div class="header-group">
          <div class="search-input-group">
            <input type="text" id="service-search-input" class="search-input" placeholder="Filtrar por título o descripción..." onkeyup="app.userPrivateController.list.FilterKey(event)">
            <div id="search-btn" class="search-btn" onclick="app.userPrivateController.list.Filter()"></div>
          </div>
        </div>
        <div class="header-group">
          ${app.userPrivateController.view.renderPublishButton('1')}
        </div>
        <div class="header-group">
          <button class="btn-icon" onclick="app.userPrivateController.list.Icon()"></button>
          <button class="btn-list" onclick="app.userPrivateController.list.List()"></button>
        </div>
        <button onclick="app.userPrivateController.inmuebles.new()">+ Nuevo</button>
      </div>
    `;
  }

  renderForm(_data) {
    let isNew = false;
    if (!_data) {
      _data = {};
      isNew = true;
    }
    let html = `
    <div class="form">
      <input type="hidden" id="inmuebles-idcod" value="${_data.idcod || ''}"> 
      <h2 class="mb0 ancho">Datos de mi inmueble</h2>
      <div class="group sb">
        <div class="group">
          <b>Categoría</b>
          <select id="inmuebles-categoria" value="${_data.categoria || ''}"></select>
          <span id="inmuebles-categoria-error"></span>
        </div>
        <div class="group">
          <b>Título</b>
          <input type="text" id="inmuebles-titulo" value="${_data.titulo || ''}"> 
          <span id="inmuebles-titulo-error"></span>
        </div>
        <div class="group">
          <b>Descripción corta</b>
          <textarea id="inmuebles-resumen" rows="5">${_data.resumen || ''}</textarea> 
          <span id="inmuebles-resumen-error"></span>
        </div>
      </div>
      <div class="group">
        <b>Imágenes</b>
        ${this.gallery.create(_data.imagenes)}
      </div>
      <div class="group">
        <b>Superficie</b>
        <input type="text" id="inmuebles-metros"  value="${_data.metros || ''}"> 
        <span id="inmuebles-metros-error"></span>
      </div>
      ${app.userPrivateController.view.renderPriceOptions('inmuebles', _data, isNew)}
      <div class="group">
        <b>Provincia</b>
        <select id="inmuebles-provincia" value="${_data.provincia || ''}" onchange="
        APICRUD.Location.Selector_LoadCities('inmuebles-localidad', this.value, '${_data.localidad}')
        "></select>
        <span id="inmuebles-provincia-error"></span>
      </div>
      <div class="group">
        <b>Localidad</b>
        <select id="inmuebles-localidad" value="${_data.localidad || ''}"></select>
        <span id="inmuebles-localidad-error"></span>
      </div>
      <div class="group span">
        <b>Descripción completa del inmueble</b>
        <textarea id="inmuebles-descripcion" rows="10">${_data.descripcion || ''}</textarea> 
        <span id="inmuebles-descripcion-error"></span>
      </div>
    </div>

    <div class="form-footer">
      <button class="mt20" onclick="app.userPrivateController.inmuebles.save()">${_data.idcod ? 'Guardar cambios' : 'Crear inmueble'}</button>
    `;

    if (_data.idcod) {
      html += `
        <button class="mt20 bg-red fr" onclick="app.userPrivateController.inmuebles.delete('${_data.titulo || ''}', '${_data.idcod || ''}')">Eliminar</button>
      `;
    }

    html += `
      <span id="inmuebles-status" class="mt20"></span>
    </div>
    `;

    return html;
  }

  renderItemCollection(_items, _id) {
    let html = '';

    if (_items.data.length > 0) {
      html = `
        <div class="content items id="${(_id || '')}">">
          ${_items.data.map(i => this.renderItem(i)).join('')}
        </div>
        `;
    } else {
      html = `
        <p> No hay publicaciones, cree su primer inmueble ahora. </p>
        <br>
        <button onclick="app.userPrivateController.inmuebles.new()">+ Crear mi primer inmueble</button>
      `;
    }
    return html;
  }

  renderItem(_item) {
    let images = _item.imagenes;
    if (images && typeof images == 'string' && images.length > 0) {
      try {
        images = JSON.parse(images);
      } catch (error) {
        console.log(error, images);
      }
    }
    if (!Array.isArray(images)) {
      images = [];
    }
    return `
    <article>
      <div class="item pb20" onclick="app.userPrivateController.inmuebles.edit('${_item?.idcod}')">
        <img src="${images.length > 0 ? APICRUD.Image.GetUrl(images[0]) : ''}" alt="" onerror="this.src='/assets/img/service.webp'">
        <h1>${_item?.titulo || 'Sin título'}</h1>
        <p>${_item?.resumen || ''}</p>
      </div>
    </article>
  `;
  }

  renderDeleteConfirmation(_title, _idcod) {
    return ` <h2>¿Seguro desea eliminar el inmueble <b class="cr">${_title}</b>?</h2>
      <button class="bg-red" onclick="app.userPrivateController.inmuebles.deleteConfirmation('${_idcod}')">Eliminar</button>
      <button class="fr" onclick="app.userPrivateController.inmuebles.deleteCancel()">Conservar</button>
      `;
  }


}
